import React from 'react';
import PageHeader from './components/PageHeader';
import SettingsPPMDiscountTiers from './SettingsPPMDiscountTiers';

function PPMDiscountTiersPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="PPM Discount Tiers"
        subtitle="Configure volume discount tiers"
        backTo="/settings/finance"
        backLabel="Finance"
        sticky
      />
      <div className="p-6">
        <SettingsPPMDiscountTiers />
      </div>
    </div>
  );
}

export default PPMDiscountTiersPage;
